const Hero = () => (
  <section id="home" className="parallax">
    <div className="content">
      <h2 className="text-5xl md:text-6xl font-bold text-[#FFD700] mb-4 text-shadow-md">B & G Fitness: Ignite Your Strength</h2>
      <p className="text-lg md:text-xl text-white mb-6">Tarboro, NC’s ultimate gym to fuel your fitness fire with epic workouts and a tight-knit crew!</p>
      <a href="#contact" className="inline-block bg-[#32cd32] text-[#222] px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#28a745] hover:scale-105 transition-all">Join the Squad</a>
    </div>
  </section>
);

export default Hero;